import React, { Component } from 'react';

const ProviderManagement = () => {
	return ( <h1>Provider Management</h1> );
}
 
export default ProviderManagement;